import { Card, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

function RestartHistoryTable() {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const { state } = useLocation();
    const { hotel_id, kiosk_id } = state;
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        hotel_id,
        kiosk_id,
        limit: 10,
        page: 0,
    });
    const {
        status: historyStatus,
        data: historyRes,
        refetch: getHistory,
    } = useQuery(
        `restart-history-${kiosk_id}`,
        async () => {
            return await HTTP("/hotels/getServiceRestartHistory", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getHistory();
    }, []);

    useEffect(() => {
        getHistory();
    }, [formData]);

    useEffect(() => {
        if (historyStatus === "success") {
            const { data: tableData, total } = historyRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [historyStatus, historyRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    const columns = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
        },
        {
            title: "Kiosk Name",
            dataIndex: "kiosk_name",
            key: "kiosk_name",
            sorter: () => {},
        },
        {
            title: "Restarted By",
            dataIndex: "first_name",
            render: (text, record) => (
                <span>{`${record.first_name} ${record.last_name}`}</span>
            ),
            sorter: () => {},
        },
        {
            title: "Service Restarted",
            render: (text, record) => {
                let service_restarted = "";
                if (record.is_for == "3") {
                    service_restarted =
                        record.operation_type === 1 ? "HIM" : "ASM";
                } else {
                    service_restarted =
                        record.is_for == 1 ? "Smart Plug" : "Smart CC";
                }
                return <span>{service_restarted}</span>;
            },
        },
        {
            title: "Date",
            key: "created_at",
            dataIndex: "created_at",
            render: (text) => formatDate(text, "MM/DD/YYYY HH:MM:SS"),
            sorter: () => {},
        },
    ];

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            {historyStatus === "loading" || historyStatus === "idle" ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            ) : (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    noOfrecords={totalRecords}
                    handleTableChange={handleTableChange}
                    rowKey="id"
                />
            )}
        </Card>
    );
}

export { RestartHistoryTable };
